import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  setTotalTabs,
  setProgress
} from '../factories/progressTracker/progressTracker';
import { transition } from '../store/actions';

class ProgressTracker extends React.Component {
  componentDidMount() {
    setTotalTabs(this.props.steps.length);
    this.update(this.props.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.steps !== this.props.steps) {
      setTotalTabs(this.props.steps.length);
    }
    if (prevProps.location !== this.props.location) {
      this.update(this.props.location.pathname, prevProps.location.pathname);
    }
  }

  update(pathname = '', prevPathname = '') {
    const { dispatch, steps } = this.props;
    const stepsMap = new Map(
      steps.items.map(step => {
        return [step.path, step.key];
      })
    );
    const key = pathname
      .split('/')
      .slice(0, 2)
      .join('/');
    const prevKey = prevPathname
      .split('/')
      .slice(0, 2)
      .join('/');
    if (stepsMap.has(key)) {
      setProgress(stepsMap.get(key));
      dispatch(transition(stepsMap.get(key), stepsMap.get(prevKey)));
    }
  }

  render() {
    return null;
  }
}

export default withRouter(connect()(ProgressTracker));
